import React from "react";
import { Formik, Form } from "formik";
import SchemaFormChangeHandlerView from "components/util/schema_form/SchemaForm.sub.ChangeHandler.view";
import SchemaHandler from "components/util/schema_form/SchemaForm.sub.SchemaHandler.view";
import "styles/css/util/schema_form/Form.css";


const SchemaFormView = ({
  formRef,
  componentRef,
  schema = [],
  appId,
  actionId,
  flowId,
  parentId,
  nodeId,
  executionId,
  initialValues = {},
  dataReqs,
  submitText = "Guardar",
  submitComponent,
  showSideSteps = true,
  isPreview,
  isDeveloper,
  isReadOnly = false,
  isCommentEnabled = false,
  onChange = () => { },
  onSubmit
}) => (
  <div>
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={onSubmit}>
      {({ values, setValues, setFieldValue }) => (
        <Form className="schema-form" ref={componentRef}>
          <SchemaFormChangeHandlerView onChange={onChange} values={values} />
          <SchemaHandler schema={schema} appId={appId} actionId={actionId} flowId={flowId} executionId={executionId}
            nodeId={nodeId} values={values} dataReqs={dataReqs} setFieldValue={setFieldValue} setValues={setValues}
            showSideSteps={showSideSteps} isDeveloper={isDeveloper} parentId={parentId}
            isReadOnly={isReadOnly} isCommentEnabled={isCommentEnabled}
          />
          {function () {

            let showSubmitButton = true;
            if (!schema) return <></>;

            // Determine which inputs are required
            const requiredInputs = [];

            for (const input of schema?.fields ?? []) {

              let showInput = true;
              const showConditions = input.show_if;

              if (!showConditions) {
                requiredInputs.push(input)
                continue;
              }

              for (const conditional of showConditions) {
                const variable = conditional?.variable ?? "";
                const value = conditional?.value ?? "";
                const condition = conditional?.condition ?? "EQUAL";

                switch (condition) {
                  case "EQUAL":
                    if (!(values[variable] == value)) showInput = false;
                    break;

                  case "NOT_EQUAL":
                    if (!(values[variable] != value)) showInput = false;
                    break;

                  case "GRATER_THAN":
                    if (!(values[variable] > value)) showInput = false;
                    break;

                  case "LOWER_THAN":
                    if (!(values[variable] < value)) showInput = false;
                    break;

                  case "GRATER_THAN_OR_EQUAL":
                    if (!(values[variable] >= value)) showInput = false;
                    break;

                  case "LOWER_THAN_OR_EQUAL":
                    if (!(values[variable] <= value)) showInput = false;
                    break;

                  case "CONTAINS":
                    if (!(values[variable].includes(value))) showInput = false;
                    break;

                  default:
                    break;
                }
              }

              if (showInput) {
                requiredInputs.push(input)
              }

            }

            for (const input of requiredInputs) {
              let required = input?.required ?? true;
              if (input?.hidden == true) required = false;
              const name = input?.name ?? "";

              if (!required) continue;
              if (values[name] == null || values[name] === "") {
                showSubmitButton = false;
                break;
              }
            }

            if (showSubmitButton) {
              return (
                <div className={(showSideSteps ? "pl-8 pr-4 my-1" : "px-5 mt-2 mb-1")}>
                  {
                    submitComponent ? React.createElement(submitComponent, {
                      values: values,
                      setFieldValue: setFieldValue,
                    }) :
                      <button 
                        type={isPreview ? "button" : "submit"}
                        className="btn btn-block btn-primary font-weight-bold"
                      >
                        {submitText}
                      </button>
                  }

                </div>
              )
            }

            return <></>

          }()}

        </Form>
      )}
    </Formik>

  </div>
)
export default SchemaFormView;